import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, FileText, Shield, Lightbulb, Heart, FileCheck, Lock } from 'lucide-react';
export function HelpfulInfo() {
  const infoPages = [{
    name: 'FAQs',
    path: '/12.html',
    icon: <BookOpen className="w-8 h-8" data-id="element-949" />,
    description: 'Common questions about our services, ordering, and processes'
  }, {
    name: 'Compliance',
    path: '/Compliance',
    icon: <Shield className="w-8 h-8" data-id="element-950" />,
    description: 'Our commitment to industry standards and regulations'
  }, {
    name: 'Screen Printing Advice',
    path: '/Screen-Printing-Advice',
    icon: <Lightbulb className="w-8 h-8" data-id="element-951" />,
    description: 'Tips and best practices for screen printing projects'
  }, {
    name: 'What is Vector Art?',
    path: '/What-is-Vector-Art',
    icon: <FileText className="w-8 h-8" data-id="element-952" />,
    description: 'Understanding vector graphics and file requirements'
  }, {
    name: 'The Wear Haus Way',
    path: '/The-Wear-Haus-Way',
    icon: <Heart className="w-8 h-8" data-id="element-953" />,
    description: 'Our values, mission, and commitment to quality'
  }, {
    name: 'Terms and Conditions',
    path: '/Terms',
    icon: <FileCheck className="w-8 h-8" data-id="element-954" />,
    description: 'Legal terms and conditions for our services'
  }, {
    name: 'Privacy Policy',
    path: '/Privacy',
    icon: <Lock className="w-8 h-8" data-id="element-955" />,
    description: 'How we protect and handle your information'
  }];
  return <div className="min-h-screen bg-gray-50" data-id="element-956">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-wh-teal to-teal-600 py-20" data-id="element-957">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-958">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-959">
            Helpful Information
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto" data-id="element-960">
            Everything you need to know about working with Wear Haus Designs
          </p>
        </div>
      </section>

      {/* Info Cards Grid */}
      <section className="py-20" data-id="element-961">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-962">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-963">
            {infoPages.map(page => <Link key={page.path} to={page.path} className="group bg-white rounded-xl p-8 shadow-sm border border-gray-200 hover:border-wh-pink hover:shadow-md transition-all duration-300" data-id="element-964">
                <div className="flex items-start gap-4" data-id="element-965">
                  <div className="flex-shrink-0 w-14 h-14 bg-gray-50 rounded-lg flex items-center justify-center text-gray-600 group-hover:bg-pink-50 group-hover:text-wh-pink transition-colors" data-id="element-966">
                    {page.icon}
                  </div>
                  <div className="flex-1" data-id="element-967">
                    <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-wh-pink transition-colors" data-id="element-968">
                      {page.name}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed" data-id="element-969">
                      {page.description}
                    </p>
                  </div>
                </div>
              </Link>)}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-white border-t border-gray-100" data-id="element-970">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-971">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-972">
            Still Have Questions?
          </h2>
          <p className="text-xl text-gray-600 mb-8" data-id="element-973">
            Our team is here to help with any questions about our services or
            processes.
          </p>
          <Link to="/Contact" className="inline-flex items-center justify-center px-8 py-4 bg-wh-pink text-white font-bold rounded-lg hover:bg-pink-600 transition-colors shadow-lg" data-id="element-974">
            Contact Us
          </Link>
        </div>
      </section>
    </div>;
}